import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { notificationApiRef } from '../notificationApiRef';
import { WEBHOOK_KEY } from './reactQuery';
import { WebhookGetRequest } from '@agilelab/plugin-wb-notification-common';

export const useWebhook = (
  request: WebhookGetRequest,
  options?: { enabled?: boolean },
) => {
  const notificationApi = useApi(notificationApiRef);

  return useQuery({
    queryKey: [WEBHOOK_KEY, request.uuid, request],
    queryFn: () => notificationApi.getWebhook(request),
    enabled: !!request && (options?.enabled ?? true),
  });
};
